import type { JSX } from "react";
import { useInputStore, useScannerStore, useViewStore } from "../../store";
import { CurrentView } from "../../types/types";
import type { ScanResult } from "../../types/types";
import { QrCodeView } from "./components/qr-code-view";

interface ScannerDesktopProps {
  onClose: () => void;
  onBack?: () => void;
}
export function ScannerDesktop({ onClose, onBack }: ScannerDesktopProps): JSX.Element {
  const { setScanID } = useInputStore((store) => store);
  const { setCurrentView } = useViewStore((store) => store);
  const flowType = useScannerStore((store) => store.flowType);

  const onScan = (sr: ScanResult): void => {
    setScanID(sr.id);
    setCurrentView(CurrentView.Result);
  };

  return <QrCodeView onBack={onBack} onClose={onClose} onScan={onScan} flowType={flowType} />;
}
